<div>
    <h2>{{'gestionRoyalties.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionRoyalties.filters.entidadControl' | translate}} *</label>
                <app-filterable-list [itemsList]="entidadesControl" [selectedItem]="filtersForm.get('entidadControl')"
                [placeHolder]="false" [disabled]="disabledEntidadControl"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}}</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false" [disabled]="disabledPaises"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionRoyalties.filters.denominacion' | translate}}</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [placeHolder]="false" [disabled]="disabledDenominaciones"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'gestionRoyalties.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [placeHolder]="false" [disabled]="disabledMarcas"></app-filterable-list>
            </div>
            <div *ngIf="pestanaActiva === 1" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'gestionRoyalties.filters.productor' | translate}}</label>
              <app-filterable-list [itemsList]="productores" [selectedItem]="filtersForm.get('productor')"
              [disabled]="disabledProductores">
              </app-filterable-list>
            </div>
            <div *ngIf="pestanaActiva === 2" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <label>{{'gestionRoyalties.filters.etiquetador' | translate}}</label>
              <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
              [disabled]="disabledEtiquetadores">
              </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <input type="checkbox" id="asociadoMarca" formControlName="asociadoMarca" (click)="onAsociadoMarca($event)">
              <label for="asociadoMarca">{{'gestionRoyalties.filters.sinMarcaAsociada' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons" *ngIf="pestanaActiva === 1">
      <i class="fas fa-file-pdf" (click)="exportPdfOrExcel(1, null, null)"
        title="{{'global.modalInformes.titulo' | translate}} PDF"
        [ngClass]="{'disabled': !royaltiesProductor || royaltiesProductor.length < 1 }"></i>
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <section class="export-buttons" *ngIf="pestanaActiva === 2">
      <i class="fas fa-file-pdf" (click)="exportPdfOrExcel(1, null, null)"
        title="{{'global.modalInformes.titulo' | translate}} PDF"
        [ngClass]="{'disabled': !royaltiesEtiquetador || royaltiesEtiquetador.length < 1 }"></i>
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <content class="tabs">
      <form *ngIf="royalties && totalesVisible">
        <h3 *ngIf="!filterEtqApplied">{{'gestionRoyalties.totales.tituloProductores' | translate}}</h3>
        <section *ngIf="!filterEtqApplied" class="info-framed">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'gestionRoyalties.totales.superficie' | translate}}</label>
                <span>{{ (royalties.superficie_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'gestionRoyalties.totales.plantas' | translate}}</label>
                <span>{{ (royalties.nPlantas_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'gestionRoyalties.totales.pesoProducido' | translate}}</label>
                <span>{{ (royalties.kilos_Productor_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'gestionRoyalties.totales.total' | translate}}</label>
              <span>{{ (royalties.total_Productor_Fee | number : '1.2-2' : defaultLanguage)}} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
        </section>
        <h3 *ngIf="!filterProdApplied">{{'gestionRoyalties.totales.tituloEtiquetadores' | translate}}</h3>
        <section *ngIf="!filterProdApplied" class="info-framed">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label></label>
                <span></span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label></label>
                <span></span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'gestionRoyalties.totales.pesoEtiquetado' | translate}}</label>
              <span>{{ (royalties.kilos_Etiquetador_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'gestionRoyalties.totales.total' | translate}}</label>
              <span>{{ (royalties.kilos_Etiquetador_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
        </section>
        <h3>{{'gestionRoyalties.totales.tituloTotales' | translate}}</h3>
        <section class="info-framed">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'gestionRoyalties.totales.superficie' | translate}}</label>
                <span>{{ (royalties.superficie_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'gestionRoyalties.totales.plantas' | translate}}</label>
                <span>{{ (royalties.nPlantas_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'gestionRoyalties.totales.peso' | translate}}</label>
                <span>{{ (royalties.total_Kilos_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
              <label>{{'gestionRoyalties.totales.total' | translate}}</label>
              <span>{{ (royalties.total_Fee | number : '1.2-2' : defaultLanguage) }} {{ unidadesMedida.divisas.symbol }}</span>
            </div>
        </section>
      </form>
      <section class="filters-buttons totales-buttons" *ngIf="royalties">
        <button *ngIf="!totalesVisible" [ngClass]="{'showFilters': totalesVisible}"
            (click)="totalesVisible=!totalesVisible" title="{{'gestionRoyalties.totales.mostrarTotales' | translate}}">
            <i class="fas fa-angle-down"></i> {{'gestionRoyalties.totales.mostrarTotales' | translate}}
        </button>
        <button *ngIf="totalesVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="totalesVisible=!totalesVisible" title="{{'gestionRoyalties.totales.ocultarTotales' | translate}}">
            <i class="fas fa-angle-up"></i> {{'gestionRoyalties.totales.ocultarTotales' | translate}}
        </button>
      </section>
      <section class="tabs">
        <ul>
          <li [ngClass]="{'active': pestanaActiva === 1}" (click)="showRoyaltiesProductor()">{{'gestionRoyalties.productor.tituloProductor' | translate}}</li>
          <li [ngClass]="{'active': pestanaActiva === 2}" (click)="showRoyaltiesEtiquetador()">{{'gestionRoyalties.etiquetador.tituloEtiquetador' | translate}}</li>
        </ul>
        <content>
          <app-royalties-productor *ngIf="pestanaActiva === 1" [royaltiesProductor]="royaltiesProductor" [unidadesMedida]="unidadesMedida" [filterEtqApplied]="filterEtqApplied" [resetArrows]="resetArrowsIcon" (exportPdfProductor)="exportPdfProductor($event)"></app-royalties-productor>
          <app-royalties-etiquetador *ngIf="pestanaActiva === 2" [royaltiesEtiquetador]="royaltiesEtiquetador" [unidadesMedida]="unidadesMedida" [filterProdApplied]="filterProdApplied" [resetArrows]="resetArrowsIcon" (exportPdfEtiquetador)="exportPdfEtiquetador($event)"></app-royalties-etiquetador>
        </content>
      </section>
      <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event; showWarning=$event"></app-toast>
    </content>
</div>

